const reduceLookUpTable = lookup => {
  if (lookup !== null && lookup !== undefined) {
    const lookUpTable = JSON.parse(lookup).values.reduce((mapObject, value) => {
      return { ...mapObject, [value.from]: value.to };
    }, {});
    return lookUpTable;
  }
  return {};
};

export default reduceLookUpTable;
